<template>
  <TopBar title="Please submit your details below to see your results." subtitle="Please fill out your information below to see your results." :step="step"/>
  <div class="step">
    <p class="text">* indicates a mandatory field</p>
    <p class="text">One of our Course Consultants may be contact to help with any questions you have regarding course information, the enrolment process, entry documentation, course fees or how online study works.<br /></p>
      <div class="form-row">
        <div>
          <label for="first_name" class="sr-only">First Name</label>
          <input id="first_name" :class="{invalid: !first_name_valid}" :value="first_name" @input="setFormData($event.target.value, 'first_name')" placeholder="First Name*" @focusout="validateFormData($event.target.value, 'first_name')">
          <p class="error-label" :class="{invalid: !first_name_valid}">Incorrect or no answer submitted</p>
        </div>
        <div>
          <label for="last_name" class="sr-only">Last Name</label>
          <input id="last_name" :class="{invalid: !last_name_valid}" :value="last_name" @input="setFormData($event.target.value, 'last_name')" placeholder="Last Name*" @focusout="validateFormData($event.target.value, 'last_name')">
          <p class="error-label" :class="{invalid: !last_name_valid}">Incorrect or no answer submitted</p>
        </div>
      </div>
      <div class="form-row">
        <div>
          <label for="email" class="sr-only">Email</label>
          <input type="email" id="email" :class="{invalid: !email_valid}" :value="email" @input="setFormData($event.target.value, 'email')" placeholder="Email*" @focusout="validateFormData($event.target.value, 'email')">
          <p class="error-label" :class="{invalid: !email_valid}">Invalid email address or no answer submitted</p>
        </div>
      </div>
      <div class="form-row">
        <div>
          <label for="mobile" class="sr-only">Phone Number</label>
          <input id="mobile" :class="{invalid: !mobile_valid}" :value="mobile" @input="setFormData($event.target.value, 'mobile')" placeholder="Phone Number*" @focusout="validateFormData($event.target.value, 'mobile')">
          <p class="error-label" :class="{invalid: !mobile_valid}">Invalid phone number or no answer submitted</p>
        </div>
        <div>
          <label for="zip" class="sr-only">Postcode</label>
          <input id="zip" :class="{invalid: !zip_valid}" :value="zip" @input="setFormData($event.target.value, 'zip')" placeholder="Postcode*" @focusout="validateFormData($event.target.value, 'zip')">
          <p class="error-label" :class="{invalid: !zip_valid}">Incorrect or no answer submitted</p>
        </div>
      </div>
  </div>
  <BottomBar :step="step" :valid="valid"/>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
import TopBar from '@/components/TopBar'
import BottomBar from '@/components/BottomBar'

export default {
  props: {
    step: {
      required: true
    }
  },
  components: {
    TopBar,
    BottomBar
  },
  computed: mapState({
    first_name: state => state.formData.first_name,
    last_name: state => state.formData.last_name,
    email: state => state.formData.email,
    mobile: state => state.formData.mobile,
    zip: state => state.formData.zip
  }),
  data () {
    return {
      valid: false,
      first_name_valid: true,
      last_name_valid: true,
      email_valid: true,
      mobile_valid: true,
      zip_valid: true
    }
  },
  methods: {
    setFormData (value, key) {
      this.$store.commit('setFormData', { key, value })
    },
    validateFormData (value, key) {
      if (key === 'first_name') {
        if (value === '') {
          this.first_name_valid = false
        } else {
          this.first_name_valid = true
        }
      } else if (key === 'last_name') {
        if (value === '') {
          this.last_name_valid = false
        } else {
          this.last_name_valid = true
        }
      } else if (key === 'email') {
        const emailRegex = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")
        if (value === '' || !emailRegex.test(value)) {
          this.email_valid = false
        } else {
          this.email_valid = true
        }
      } else if (key === 'mobile') {
        const phoneRegex = new RegExp("^(\[+]?\(61\)|\(\[+]?61\)|\[+]?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$")
        if (value === '' || !phoneRegex.test(value)) {
          this.mobile_valid = false
        } else {
          this.mobile_valid = true
        }
      } else if (key === 'zip') {
        if (value === '') {
          this.zip_valid = false
        } else {
          this.zip_valid = true
        }
      }

      if (this.first_name_valid === true && first_name.value !== '' &&
          this.last_name_valid === true && last_name.value !== '' &&
          this.email_valid === true && email.value !== '' &&
          this.mobile_valid === true && mobile.value !== '' &&
          this.zip_valid === true && zip.value !== '') {
        this.valid = true
      } else {
        this.valid = false
      }
    }
  }
}
</script>
<style lang="scss">
@import "./../assets/scss/mixins";

#ec-steps.step-8 {
  .step {
    max-width: 50.5rem;
    margin: 0 auto;
    padding-bottom: 6rem;
  }

  input {
    &.invalid {
      border: 1px solid #EB0518;
      background-color: #FDEAEC;
    }
  }

  .error-label {
    display: none;
    color: #EB0518;
    position: absolute;
    font-size: 12px;
    bottom: 2px;
    left: 32px;
    margin-bottom: 0;

    @include respond-above(lg) {
      bottom: -13px;
    }

    &.invalid {
      display: block;
    }
  }

  .text {
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 1px;
    padding: 0 1rem;

    @include respond-above(lg) {
      text-align: center;
      padding: 0;
    }
  }

  button.btn-red-wide {
    padding: 5px 20px;

    @include respond-above(lg) {
      margin-right: 20px;
    }

    &:hover {
      svg {
        path {
          stroke: #da2e2e;
          fill: none !important;
        }
      }
    }
  }

  .form-row {
    flex-direction: row;

    > div {
      flex-direction: column;
      flex-basis: 100%;
      padding: 0 0 1rem;
      margin: 0 0.5rem;
      position: relative;
    }

    @include respond-above(lg) {

      > div {
        flex-basis: 475px;
        padding: 0.5rem;
      }
    }
  }

  .bottom {
    .spacer {
      display: none;
    }
  }
}
</style>
